import { getContractStatusText } from './contractStatusUtils';

/** Valores em string evitam ambiguidade com Criado = 0 no Dropdown do Semantic UI. */
export interface CampaignStatusFilterOption {
  key: string;
  value: string;
  text: string;
}

export function buildTableStatusFilterOptions(statusIds: number[]): CampaignStatusFilterOption[] {
  const uniqueIds = Array.from(
    new Set(statusIds.filter((id) => Number.isFinite(id))),
  ).sort((a, b) => a - b);

  return uniqueIds.map((statusId) => ({
    key: String(statusId),
    value: String(statusId),
    text: getContractStatusText(statusId),
  }));
}

export function parseCampaignStatusFilterValue(
  value: string | number | boolean | (string | number | boolean)[] | undefined | null,
): number | undefined {
  const raw = Array.isArray(value) ? value[0] : value;
  if (raw === undefined || raw === null || raw === '') return undefined;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : undefined;
}
